import { AxiosError } from "axios";
import { axiosFinancial, createAuthHeaders } from "./financialApi";
import { KamFilters, KamPaginatedResponse } from "@/models/kam-report.model";

export const getConsigKamReport = async (
  filters: KamFilters,
  page: number,
  pageSize: number
): Promise<KamPaginatedResponse> => {
  const response = await axiosFinancial.get("/api/consignado/kam-paginated", {
    params: { ...filters, page, pageSize },
    headers: createAuthHeaders(),
  });
  return response.data;
};

export const downloadConsigKamReport = async (
  startDate: Date | string | null,
  endDate: Date | string | null
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
  };

  try {
    const response = await axiosFinancial.get("/api/consignado/kam", {
      params,
      responseType: "blob",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/zip",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = "relatorio_kam.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};
